import { render } from "./PersonalCabinetView.vue?vue&type=template&id=6732e3c9&scoped=true"
import script from "./PersonalCabinetView.vue?vue&type=script&lang=js"
export * from "./PersonalCabinetView.vue?vue&type=script&lang=js"

import "./PersonalCabinetView.vue?vue&type=style&index=0&id=6732e3c9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6732e3c9"]])

export default __exports__